module.exports = __webpack_public_path__ + "images/checkbox_tick71730b8aec006fb9135475f36c375375.png";